// source: pbtypes/gen/skills/gimbal_pitch_handler_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.GimbalPitchHandlerParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.GimbalPitchHandlerParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.GimbalPitchHandlerParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.GimbalPitchHandlerParams.displayName = 'proto.skills.GimbalPitchHandlerParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.GimbalPitchHandlerParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.GimbalPitchHandlerParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.GimbalPitchHandlerParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.GimbalPitchHandlerParams.toObject = function(includeInstance, msg) {
  var f, obj = {
minGimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
maxGimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
pitchRateScale: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
gimbalPitchFilterTimeConstant: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.GimbalPitchHandlerParams}
 */
proto.skills.GimbalPitchHandlerParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.GimbalPitchHandlerParams;
  return proto.skills.GimbalPitchHandlerParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.GimbalPitchHandlerParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.GimbalPitchHandlerParams}
 */
proto.skills.GimbalPitchHandlerParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinGimbalPitch(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxGimbalPitch(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPitchRateScale(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchFilterTimeConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.GimbalPitchHandlerParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.GimbalPitchHandlerParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.GimbalPitchHandlerParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.GimbalPitchHandlerParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinGimbalPitch();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getMaxGimbalPitch();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getPitchRateScale();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getGimbalPitchFilterTimeConstant();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional float min_gimbal_pitch = 1;
 * @return {number}
 */
proto.skills.GimbalPitchHandlerParams.prototype.getMinGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GimbalPitchHandlerParams} returns this
 */
proto.skills.GimbalPitchHandlerParams.prototype.setMinGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float max_gimbal_pitch = 2;
 * @return {number}
 */
proto.skills.GimbalPitchHandlerParams.prototype.getMaxGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GimbalPitchHandlerParams} returns this
 */
proto.skills.GimbalPitchHandlerParams.prototype.setMaxGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float pitch_rate_scale = 3;
 * @return {number}
 */
proto.skills.GimbalPitchHandlerParams.prototype.getPitchRateScale = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GimbalPitchHandlerParams} returns this
 */
proto.skills.GimbalPitchHandlerParams.prototype.setPitchRateScale = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float gimbal_pitch_filter_time_constant = 4;
 * @return {number}
 */
proto.skills.GimbalPitchHandlerParams.prototype.getGimbalPitchFilterTimeConstant = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.GimbalPitchHandlerParams} returns this
 */
proto.skills.GimbalPitchHandlerParams.prototype.setGimbalPitchFilterTimeConstant = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


goog.object.extend(exports, proto.skills);
